/**
 * Generate a ticket type slug from project name, service type, and item name.
 * Example: "Acme Corp — Install — Router" → "acme-corp---install---router"
 */
export function slugifyTicketType(projectName, serviceType, itemName) {
  const raw = `${projectName || ''} — ${serviceType || ''} — ${itemName || ''}`;
  return raw
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
